<mat-progress-bar *ngIf="(loaded$ | async) === false" mode="indeterminate" />

<div
  *ngIf="displayType$ | async as displayType"
  fxFill
  fxLayout="column"
  fxLayoutAlign="center center"
>
  <div
    *ngrxLet="error$ as error"
    class="relative flex h-full w-full items-center justify-center"
  >
    <div *ngIf="error" class="error-message">{{ error }}</div>

    <img *ngIf="displayType === 'unsupported'" [src]="fallbackImage" />

    @if (displayType === 'image') {
      @if (readOnly$ | async) {
        <img
          class="mx-auto max-h-full max-w-full object-contain"
          alt="File preview"
          aria-label="File preview"
          [src]="fileUrl$ | async"
        />
      } @else {
        <pintura-editor
          [src]="fileUrl$ | async"
          [options]="pinturaOptions$ | async"
          (update)="onUpdate()"
        />
      }
    }

    <video *ngIf="displayType === 'video'" controls>
      <source
        *ngIf="safeUrl$ | async as url"
        [src]="url"
        [type]="contentType$ | async"
      />
      Sorry, your browser doesn't support embedded videos.
    </video>

    <audio *ngIf="displayType === 'audio'" controls>
      <source
        *ngIf="safeUrl$ | async as url"
        [src]="url"
        [type]="contentType$ | async"
      />
      Your browser does not support the audio element.
    </audio>

    <ng-container *ngIf="displayType === 'iframe'">
      <iframe
        *ngIf="safeUrl$ | async as url"
        fxFill
        [src]="url"
        (load)="loaded$.next(true)"
        (error)="handleError()"
      ></iframe>
    </ng-container>

    <ng-container *ngIf="displayType === 'docViewer'">
      <ngx-doc-viewer
        *ngIf="fileUrl$ | async as url"
        fxFill
        viewer="google"
        [url]="url"
        [googleCheckContentLoaded]="true"
        [googleCheckInterval]="3000"
        [googleMaxChecks]="5"
        (loaded)="loaded$.next(true)"
      />
    </ng-container>
  </div>
</div>
